// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","positionFixed":"App_positionFixed__aaRqG"};